import { CancelConfirmationModalProps } from './types'
import { Button, Content, StyledModal } from './styles'

function CancelConfirmationModal({
  isModalOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: CancelConfirmationModalProps) {
  const modalContent = {
    title: 'คุณต้องการยกเลิกการสร้างเคส',
    content: 'หากยกเลิกจะต้องทำรายการใหม่ทั้งหมด',
    confirmText: 'ยืนยัน',
    cancelText: 'ยกเลิก',
  }

  return (
    <StyledModal
      open={isModalOpen}
      closable={false}
      width={350}
      onCancel={onClose}
      title={modalContent.title}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={isLoading}>
          {modalContent.cancelText}
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={onConfirm}
          loading={isLoading}
          disabled={isLoading}
        >
          {modalContent.confirmText}
        </Button>,
      ]}
    >
      <Content>{modalContent.content}</Content>
    </StyledModal>
  )
}

export default CancelConfirmationModal
